import type { FC } from 'react';

import type { TIconProps } from './icon.props';

const IconPanelLeftClose: FC<TIconProps> = ({ size = 16, ...rest }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.33333"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M12.6667 2H3.33333C2.59695 2 2 2.59695 2 3.33333V12.6667C2 13.403 2.59695 14 3.33333 14H12.6667C13.403 14 14 13.403 14 12.6667V3.33333C14 2.59695 13.403 2 12.6667 2Z"
    />
    <path
      d="M6 2V14"
    />
    <path
      d="M10.6667 10L8.66667 8L10.6667 6"
    />
  </svg>
);

export {
  IconPanelLeftClose,
};
